import { CashDetail } from "./CashDetail";
import { CashCountTotals } from "./content/CashCountTotals";
import { CashTypeEnum } from "./enums/CashTypeEnum";
import { StockTypeEnum } from "./enums/StockTypeEnum";

export class StockContent {
    /** Stock index */
    stockIndex: number = -1;

    /** Stock Type */
    stockType: StockTypeEnum = StockTypeEnum.Unknown;

    /** Contenuto di questo magazzino */
    content: CashDetail[] = [];

    /**
     * Metodo di parsing
     * @param obj
     */
    public parse(obj: any) {
        if (obj.StockIndex != null) this.stockIndex = obj.StockIndex;

        if (obj.StockType != null && Object.values(StockTypeEnum).includes(obj.StockType)) this.stockType = obj.StockType;

        if (obj.Content && obj.Content.length > 0) {
            obj.Content.forEach((e) => {
                let m: CashDetail = new CashDetail();
                m.parse(e);
                this.content.push(m);
            });
            CashDetail.sort(this.content);
        }
    }

    /**
     * Metodo che mi restituisce l'importo totale e la quantità totale
     * di una lista di CashDetail filtrando per CashType o per valuta.
     * @param type CashType su cui si vuole eventualmente filtrare
     * @param currency Valuta su cui si vuole eventualmente filtrare
     */
    public getTotals(type?: CashTypeEnum, currency?: string): CashCountTotals {
        const result: CashCountTotals = {
            totalAmount: 0,
            totQty: 0,
        };

        this.content.forEach((item: CashDetail) => {
            let add = true;
            if (type && item.denomination.type != type) {
                add = false;
            }
            if (currency && item.denomination.currency != currency) {
                add = false;
            }
            if (add) {
                result.totalAmount += item.denomination.value * item.quantity;
                result.totQty += Number(item.quantity);
            }
        });
        if (currency) {
            result.currency = currency;
        }
        return result;
    }

    /**
     * Metodo che mi restituisce la lista di tutte le valute contentute
     * in una lista di cashDetails.
     */
    public getCurrencies(): string[] {
        let currencies: string[] = [];
        this.content.forEach((cashDetail: CashDetail) => {
            if (currencies.indexOf(cashDetail.denomination.currency) < 0) {
                currencies.push(cashDetail.denomination.currency);
            }
        });
        return currencies;
    }

    /**
     * Metodo che mi restituisce, per tutte le valute, l'importo totale e
     * la quantità totale di una lista di CashDetail.
     */
    public getTotalsByCurrencies(): CashCountTotals[] {
        let result: CashCountTotals[] = [];
        this.getCurrencies().forEach((currency: string) => {
            let cur = this.getTotals(undefined, currency);
            result.push(cur);
        });
        return result;
    }
}
